import React, {useContext} from 'react';
// import logo from './../images/EDVES-LOGO 2.png';
import defaultPic from './../images/defaultPic.png';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import HamburgerSvg from '../svg/HamburgerSvg';
import {DataContext} from '../context/DataContext';

export const tabItems = [
    {
        label: "Locker",
        path: "locker"
    },
    {
        label: "CBT",
        path: "cbt"
    },
    {
      label: "Chatroom",
      path: "chatroom"
    }
];

const TabItemContainer = ({ children }) => (
    <div>{children}</div>
);


const TabItem = ({item}) => {
    const location = useLocation();
    const isCurrentRoute = location.pathname === `/${item.path}`;
    const classes = classNames({
        'px-4 mx-4 -mb-2 py-1 leading-4 text-sm text-gray-100 flex flex-column justify-center items-end font-semibold': true,
        'text-gray-200 hover:text-blue-100 transform transition ease-in-out duration-100': !isCurrentRoute,
        'text-blue-100': isCurrentRoute
    });
    const showBar = classNames({
        'w-24 mx-4 -mb-2 h-1 inline-block': !isCurrentRoute,
        'w-24 mx-4 -mb-2 h-1 bg-blue-100 inline-block rounded-t': isCurrentRoute
    })

    const BottomBar = () => (
      <span className={showBar} />
    );
    
    return (
        // <div className={`${(localStorage.getItem('schoolDomain') !== 'demo.edves.net' && item.label === 'Chatroom') && 'hidden'}`}>
        <div>
          <Link to={item.path} className={classes}>
              {item.label}
          </Link>
          <BottomBar />
        </div>
    )
}


const Tabs = () => {
  const dataContext = useContext(DataContext);
  // console.log(dataContext.hideSidebar)
  return (
    <>
      { tabItems.map((items, i) => (
        <>
          <TabItemContainer className='flex flex-column' key={i}>
            <TabItem item={items} />
          </TabItemContainer>
        </>
      ))}
    </>
  )
}

const Navbar = () => {
  const dataContext = useContext(DataContext);
  const showMenu = dataContext.showMenu;
  const schoolLogo = JSON.parse(localStorage.getItem('subSchoolData')).school_logo;
  const studentPassport = JSON.parse(localStorage.getItem('studentInfo'))[0].studentpassport;
  const setDisplaySidebar = () => {
    dataContext.setShowMenu(!showMenu);
  }
  return (
    <nav className="flex fixed top-0 z-50 w-full justify-between px-4 bg-white h-16 items-center">
      <div onClick={() => setDisplaySidebar()} className='block sm:hidden cursor-pointer'>
        <HamburgerSvg />
      </div>
      <div className="w-12 h-12">
        <img src={schoolLogo} alt='logo' className="w-full object-cover" />
      </div>
      <div className= 'hidden sm:flex -mb-6' ><Tabs /></div>
      <div className="w-12 h-12" >
        <img src={studentPassport ? studentPassport : defaultPic} alt='passport' className="h-full text-xs w-full object-cover rounded-full" />
      </div>
    </nav>
  );
};

export default Navbar;
